module.exports = __webpack_public_path__ + "static/media/ve.pictogram.9d4d12fd.svg";